/**
 * Typed localStorage keys. All keys use three segments: context.domain.property
 * so they are prefixed with `context` and dot-delimited.
 *
 * Add new keys here to keep storage keys discoverable and type-safe.
 */
export const LOCAL_STORAGE_KEYS = {
	/** Current organization id for the authenticated user (auth flow / claims). */
	auth: {
		organizationId: 'context.auth.organizationId',
	},
	/** Companion code storage. Use a distinct property per companion app so apps don't share state. */
	companion: {
		code: 'context.companion.code',
		chemicalsCode: 'context.companion.chemicalsCode',
	},
	/** JSON blob keyed by org + user scope inside the payload. */
	preferences: {
		userState: 'context.preferences.userState',
	},
} as const;

/** Extracts all string values from a nested object. */
type AllValues<T> = T extends string
	? T
	: T extends object
		? { [K in keyof T]: AllValues<T[K]> }[keyof T]
		: never;

export type LocalStorageKey = AllValues<typeof LOCAL_STORAGE_KEYS>;
